import styled, { css } from 'styled-components';
import { theme } from 'styled-tools';

export const ContentWrpper = styled.div`
  width: 100%;
  max-width: 940px;
  margin: 0 auto;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex: 1;
  margin-bottom: 8px;
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
`;

export const SizeWrapper = styled.div`
  width: 120px;
`;

export const PriceWrapper = styled.div`
  width: 200px;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const CommentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 8px;
`;

export const CaptionWrapper = styled.div`
  ${theme('divStyle.margin_bottom_4')}
`;
